import React, {useContext} from 'react';
import {ChangeRequestContext} from '../context/ChangeRequestProvider';
import {CalendarChangeRequestContext} from '../context/CalendarChangeRequestProvider';
import ChangeRequestOverviewHeader from '../components/ChangeRequestOverviewHeader';
import ChangeRequestOverviewDetails from '../components/ChangeRequestOverviewDetails';
import {Row, Container} from 'react-bootstrap';

function ChangeRequestOverviewContainer(props) {    

    const { changeRequestDetails } = useContext(ChangeRequestContext); 
    const { remarksOptions } = useContext(CalendarChangeRequestContext);  
    return (
        <>
            {changeRequestDetails && remarksOptions && remarksOptions.length > 0 && 
                <Container>  
                    <Row>
                        <ChangeRequestOverviewHeader BusinessPartnerCode={!props.isNmbsUser ? props.BusinessPartnerCode : undefined}
						             isCrOverviewDetails = {changeRequestDetails && changeRequestDetails.length > 0}/>
                    </Row>
                    {/* <Row className="change-request-overview-btn-row"/> */}
                    <Row>
                        <ChangeRequestOverviewDetails remarksOptions = {remarksOptions}
                            changeRequestDetails = {changeRequestDetails}
                            isNmbsUser={props.isNmbsUser}
                            isEditAccess={props.isEditAccess}
                        />
                    </Row>
                </Container>
            }
        </>
    );
}

export default ChangeRequestOverviewContainer;